import { Button, Col, Input, Row } from 'reactstrap';
import React from 'react';
import { ShiftType } from '@ms/timesheets/dist/models/shift-type';
import DateTypedInput from 'components/form-components/date-typed-input.component';
import { ITimesheetEditEntryState } from './timesheet-edit-entry.component';
import SimpleSelect from 'components/form-components/simple-select.component';
import TimeInput from 'components/form-components/time-input.component';

import 'features/pending-timesheets/styles/timesheet-edit-entry.mobile.scss';
import { TextLogic } from 'features/pending-timesheets/logic/text.logic';
import { ReactComponent as DeleteIcon } from 'images/delete.svg';
import classNames from 'classnames';

const renderMobile = ({
    handleChangeDate,
    inputClass,
    selectedTimesheet,
    shiftTypes,
    timeEntry,
    updateEntry,
    updatedTimeEntry,
    entryKey,
    showAddDelete,
    deleteMsg,
    totalHours,
    isTimeEntryChanged,
    timeInValid,
    timeOutValid,
    lunchInValid,
    lunchOutValid,
    showCostCenters,
    costCenters,
}: ITimesheetEditEntryState): JSX.Element => {
    if (!updatedTimeEntry.isActive && showAddDelete) {
        return (
            <Row className={'pay-cycle-separator pay-cycle-separator-mobile border-top border-bottom'}>
                <Col>
                    {deleteMsg}
                    <Button color="link" size="sm" onClick={() => updateEntry('isActive', true)}>
                        Undo
                    </Button>
                </Col>
            </Row>
        );
    }

    return (
        <div className={'mobile-timeentry'}>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`entryDate-${timeEntry.id}`}>
                        Date
                    </label>
                </Col>
                <Col className={'right-control mt-3 mt-sm-2'}>
                    <DateTypedInput
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('entryDate')}
                        id={`entryDate-${timeEntry.id}`}
                        name="Entry Date"
                        onChange={handleChangeDate}
                        value={updatedTimeEntry?.entryDate}
                    />
                </Col>
            </Row>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`shifttype-${timeEntry.id}`}>
                        Type
                    </label>
                </Col>
                <Col className={'right-control mobile-only mt-3 mt-sm-2'}>
                    <SimpleSelect
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('shiftType')}
                        id={`shifttype-${timeEntry.id}`}
                        name="Shift Type"
                        onChange={(e: string) => updateEntry('shiftType', e)}
                        options={shiftTypes}
                        value={TextLogic.spaceOutCapitalization(ShiftType[updatedTimeEntry?.shiftType])}
                    />
                </Col>
            </Row>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`shiftin-${timeEntry.id}`}>
                        Shift In
                    </label>
                </Col>
                <Col className={'right-control mt-3 mt-sm-2'}>
                    <TimeInput
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('timeIn')}
                        id={`shiftin-${timeEntry.id}`}
                        name={'Shift In' + entryKey}
                        onChange={(e: string) => updateEntry('timeIn', e)}
                        value={updatedTimeEntry?.timeIn}
                        isValid={timeInValid}
                    />
                </Col>
            </Row>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`breakout-${timeEntry.id}`}>
                        Break Out
                    </label>
                </Col>
                <Col className={'right-control mt-3 mt-sm-2'}>
                    <TimeInput
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('lunchOut')}
                        id={`breakout-${timeEntry.id}`}
                        name={'Break Out' + entryKey}
                        onChange={(e: string) => updateEntry('lunchOut', e)}
                        value={updatedTimeEntry?.lunchOut}
                        isValid={lunchOutValid}
                    />
                </Col>
            </Row>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`breakin-${timeEntry.id}`}>
                        Break In
                    </label>
                </Col>
                <Col className={'right-control mt-3 mt-sm-2'}>
                    <TimeInput
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('lunchIn')}
                        id={`breakin-${timeEntry.id}`}
                        name={'Break In' + entryKey}
                        onChange={(e: string) => updateEntry('lunchIn', e)}
                        value={updatedTimeEntry?.lunchIn}
                        isValid={lunchInValid}
                    />
                </Col>
            </Row>
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`shiftout-${timeEntry.id}`}>
                        Shift Out
                    </label>
                </Col>

                <Col className={'right-control mt-3 mt-sm-2'}>
                    <TimeInput
                        disabled={!!selectedTimesheet.onlineApprovalDate}
                        className={inputClass('timeOut')}
                        id={`shiftout-${timeEntry.id}`}
                        name={'Shift Out' + entryKey}
                        onChange={(e: string) => updateEntry('timeOut', e)}
                        value={updatedTimeEntry?.timeOut}
                        isValid={timeOutValid}
                    />
                </Col>
            </Row>
            {showCostCenters && (
                <>
                    <Row className="form-control--transparent">
                        <Col xs={8} sm={8} className={'font-weight-bold'}>
                            <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`costCenter-${timeEntry.id}`}>
                                Cost Center
                            </label>
                        </Col>
                    </Row>
                    <Row className="form-control--transparent">
                        <Col className={'right-control mobile-only mt-3 mt-sm-2'}>
                            <SimpleSelect
                                disabled={!!selectedTimesheet.onlineApprovalDate}
                                className={inputClass('costCenterId')}
                                id={`costCenter-${timeEntry.id}`}
                                name="Cost Center"
                                onChange={(e: string) => updateEntry('costCenterId', e)}
                                options={costCenters}
                                value={updatedTimeEntry?.costCenterId}
                            />
                        </Col>
                    </Row>
                </>
            )}
            <Row className="form-control--transparent">
                <Col xs={8} sm={8} className={'font-weight-bold'}>
                    <label className={'mb-0 mb-sm-2 mt-3 mt-sm-2'} htmlFor={`hours-${timeEntry.id}`}>
                        Hours
                    </label>
                </Col>
                <Col className={'d-flex justify-content-end mt-3 mt-sm-2'}>
                    <Input
                        disabled
                        bsSize="sm"
                        value={totalHours}
                        id={`hours-${timeEntry.id}`}
                        className={classNames([
                            isTimeEntryChanged ? 'font-weight-semibold primary' : 'font-weight-normal text-muted',
                            { 'text-red': totalHours === 'Invalid' },
                        ])}
                    />
                </Col>
            </Row>
            {timeEntry.comment && (
                <Row>
                    <Col className={'my-3'}>
                        <div className={'font-weight-bold text-center'}>Shift Comment</div>
                        <div className={'text-center'}>{timeEntry.comment}</div>
                    </Col>
                </Row>
            )}
            {showAddDelete && (
                <Row>
                    <Col className={'text-center my-3'}>
                        <Button
                            color="link"
                            className="delete-button delete-button--mobile font-weight-600"
                            onClick={() => updateEntry('isActive', false)}
                        >
                            <DeleteIcon />
                            &nbsp; <u>Delete Shift</u>
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default renderMobile;
